import React from 'react';
import ProtectedRoute from '../../Components/ProtectedRoute';
import { MigrationViewController, MigrationViewControllerDelegate } from '../../Screen/Migration/MigrationController';
import { MigrationViewModel } from '../../Screen/Migration/MigrationModel';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";

export class MigrationCoordinator implements IndexCoordinatorDelegate, MigrationViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new MigrationViewModel()
        return (<ProtectedRoute requiredPermissions={['config.migrations.ver']} path="/:base/config/migrations" exact={true} component={(props: any) => {
            return (
                <MigrationViewController
                    navigation={props}
                    viewModel={viewModel}
                    delegate={this} />

            )
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }

}